






(function () {
  'use strict';

  var SEL = '.hb-drawer__ledger form, [class*="email-signup"] form';
  var SENTENCE = 'one email each chapter. nothing else.';

  function sameOriginAction(form) {
    var raw = form.getAttribute('action');
    if (!raw) return '/contact';
    var url;
    try { url = new URL(raw, window.location.href); } catch (err) { return null; }
    if (url.origin !== window.location.origin) return null;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.pathname + url.search;
  }

  function answer(form, word) {
    var row = form.parentNode;
    if (!row) return;
    var note = row.querySelector('.hb-ask-said');
    if (!note) {
      note = document.createElement('p');
      note.className = 'hb-ask-said';
      note.setAttribute('role', 'status');
      row.insertBefore(note, form.nextSibling);
    }
    note.textContent = word;
    form.setAttribute('data-said', '');

    clearTimeout(form._hbSaidT);
    if (word !== 'sent') {
      form._hbSaidT = setTimeout(function () {
        form.removeAttribute('data-said');
        note.remove();
        var i = form.querySelector('input[type="email"]');
        if (i) i.focus();
      }, 2400);
    }
  }

  function plantTrap(form) {
    if (!form || form.querySelector('input[name="hb-trap"]')) return;
    var t = document.createElement('input');
    t.type = 'text';
    t.name = 'hb-trap';
    t.tabIndex = -1;
    t.autocomplete = 'off';
    t.setAttribute('aria-hidden', 'true');
    t.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';
    form.insertBefore(t, form.firstChild);
  }

  function sayIt(form) {
    var i = form.querySelector('input[type="email"]');
    if (i && i.placeholder !== SENTENCE) i.placeholder = SENTENCE;
    var b = form.querySelector('button[aria-label]');
    if (b && b.getAttribute('aria-label') !== 'join') b.setAttribute('aria-label', 'join');
  }

  function plantAll() {
    document.querySelectorAll(SEL).forEach(function (form) {
      plantTrap(form);
      sayIt(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plantAll);
  else plantAll();
  setTimeout(plantAll, 1200);

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';

    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 2) {
      if (input) input.focus();
      return;
    }

    if (form._hbBusy) return;
    var now = Date.now();
    if (form._hbLast && now - form._hbLast < 1500) return;

    var trap = form.querySelector('input[name="hb-trap"]');
    if (trap && trap.value !== '') { answer(form, 'sent'); return; }

    if (!window.fetch || !window.FormData) { form.submit(); return; }

    var action = sameOriginAction(form);
    if (!action) { answer(form, 'try again'); return; }

    var fd = new FormData(form);
    form._hbBusy = true;
    form._hbLast = now;

    fetch(action, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      redirect: 'follow',
      referrerPolicy: 'same-origin',
      cache: 'no-store'
    }).then(function (r) {
      form._hbBusy = false;
      answer(form, r.status >= 500 ? 'try again' : 'sent');
    }).catch(function () {
      form._hbBusy = false;
      answer(form, 'try again');
    });
  }, true);
})();
